/**
 * @file: useRetryOnError.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import {
  useClearAsyncResource,
  useObservableSuspenseContext,
} from '@euler/utils/hooks';
import { nanoid } from 'nanoid/non-secure';
import { useCallback, useState } from 'react';

export type RetryableErrorContext = {
  errorBoundaryKey: string | undefined;
  retryOnError: () => void;
};

export const useRetryOnError = (
  resourceId: string,
  resourceType: 'observable' | 'async',
): RetryableErrorContext => {
  const resourceHolder = useObservableSuspenseContext();
  const clearAsyncResource = useClearAsyncResource();
  const [errorBoundaryKey, setErrorBoundaryKey] = useState<string>();
  const retryOnError = useCallback(() => {
    if (!resourceId) return;
    if (resourceType === 'observable') {
      resourceHolder.remove(resourceId);
    } else {
      clearAsyncResource(resourceId);
    }
    setErrorBoundaryKey(nanoid());
  }, [clearAsyncResource, resourceHolder, resourceId, resourceType]);
  return { errorBoundaryKey, retryOnError };
};
